import { supabase } from "../../../supabaseClient";
import * as cheerio from "cheerio";

export async function extractAllContent(url: string): Promise<string> {
  const response = await supabase.functions.invoke("extract-contents", {
    body: {
      url,
      all: true,
    },
  });

  console.log("response", response);

  return response.data.content;
}

export async function extractContent(url: string): Promise<string[]> {
  const response = await supabase.functions.invoke("extract-contents", {
    body: {
      url,
    },
  });

  console.log("response", response);

  return response.data.content;
}

export function extractTitle(html: cheerio.CheerioAPI) {
  let data = html("title").text();

  console.log("data", data);
  if (!data) {
    data = html("meta").attr("property", "og:title").text();
  }
  return data;
}

export function extractDescription(html: cheerio.CheerioAPI) {
  let data = html('meta[name="description"]').attr("content");

  console.log("data", data);

  return data;
}

export function extractImage(html: cheerio.CheerioAPI) {
  let data = html('meta[property="og:image"]').attr("content");
  console.log("data", data);

  if (!data) {
    data = html('meta[property="twitter:image"]').attr("content");
  }

  return data;
}

export function extractArticle(html: cheerio.CheerioAPI) {
  let data =  html("article").text();

  if(!data){
    data = html("content-panel").text();
  }

  if(!data){
    data = html("body").text();
  }

  return data;
}
